import { LoadingProgress } from "./LoadingProgress";

export function LoadingOverlay() {
  return (
    <div className="fixed inset-0 bg-white/95 backdrop-blur-md z-50 flex items-center justify-center">
      <div className="w-full max-w-5xl p-16">
        <LoadingProgress />
      </div>
    </div>
  );
}